import { useMemo } from 'react'
import useOfferList from 'hooks/Offers/useOfferList'
import useOffers from 'hooks/Offers/useOffers'
import useOfferMetaDataList from 'hooks/Offers/useOfferMetaDataList'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import config from 'constants/config'
import { take } from 'lib/array/arrayUtils'

export default function useSearchMapResults(filters: App.OfferListFilters, ignoreLimitForFlash?: boolean) {
  const offerList = useOfferList(filters)

  const metaData = useOfferMetaDataList(filters)

  const flashOfferIds = ignoreLimitForFlash ?
    metaData
      .filter(meta => meta.type === OFFER_TYPE_HOTEL)
      .map(meta => meta.offerId) :
      []

  const limit = config.search.mapView.pinLimit + config.search.mapView.additionalPins

  // fetch all flash offers. If there are less flash offers than the limit, add other offer types up to the limit
  const offerIds = flashOfferIds.length < config.search.mapView.pinLimit ? take(offerList.offerIds, limit) : flashOfferIds
  const [offers] = useOffers<App.Offer | App.BedbankOffer>(offerIds)

  const totalNumOffers = offerIds.length

  const fetchingList = offerList.fetching

  const error = offerList.error

  const offersLoaded = !fetchingList && !error

  const allOffersLoaded = !fetchingList && offers.length === totalNumOffers

  const noOffersAvailable = !fetchingList && offerIds.length === 0

  const result = useMemo(() => ({
    offers,
    totalNumOffers,
    fetchingList,
    error,
    offersLoaded,
    allOffersLoaded,
    noOffersAvailable,
  }), [
    offers,
    totalNumOffers,
    fetchingList,
    error,
    offersLoaded,
    allOffersLoaded,
    noOffersAvailable,
  ])

  return result
}
